/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PremiumScheduleResponseDto } from './PremiumScheduleResponseDto';
import {
    PremiumScheduleResponseDtoFromJSON,
    PremiumScheduleResponseDtoFromJSONTyped,
    PremiumScheduleResponseDtoToJSON,
    PremiumScheduleResponseDtoToJSONTyped,
} from './PremiumScheduleResponseDto';

/**
 * 
 * @export
 * @interface PremiumScheduleListResponseDto
 */
export interface PremiumScheduleListResponseDto {
    /**
     * 
     * @type {Array<PremiumScheduleResponseDto>}
     * @memberof PremiumScheduleListResponseDto
     */
    premiumSchedules: Array<PremiumScheduleResponseDto>;
}

/**
 * Check if a given object implements the PremiumScheduleListResponseDto interface.
 */
export function instanceOfPremiumScheduleListResponseDto(value: object): value is PremiumScheduleListResponseDto {
    if (!('premiumSchedules' in value) || value['premiumSchedules'] === undefined) return false;
    return true;
}

export function PremiumScheduleListResponseDtoFromJSON(json: any): PremiumScheduleListResponseDto {
    return PremiumScheduleListResponseDtoFromJSONTyped(json, false);
}

export function PremiumScheduleListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PremiumScheduleListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'premiumSchedules': ((json['premiumSchedules'] as Array<any>).map(PremiumScheduleResponseDtoFromJSON)),
    };
}

export function PremiumScheduleListResponseDtoToJSON(json: any): PremiumScheduleListResponseDto {
    return PremiumScheduleListResponseDtoToJSONTyped(json, false);
}

export function PremiumScheduleListResponseDtoToJSONTyped(value?: PremiumScheduleListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'premiumSchedules': ((value['premiumSchedules'] as Array<any>).map(PremiumScheduleResponseDtoToJSON)),
    };
}

